import React, { memo } from 'react'
import { Autocomplete } from 'components/forms/autocomplete/Autocomplete'
import PropTypes from 'prop-types'
import { INPUT_ID, TEST_IDS } from './constants'

const { AUTOCOMPLETE } = TEST_IDS

export const Editing = memo(
  ({
    autocomplete,
    clickHandler,
    companyId,
    handleUserChange,
    inputId,
    maxLength,
    setValue,
    type,
    value,
  }) => {
    const inputChangeHandler = ({ target: { value: nextValue } }) => setValue(nextValue)

    const onBlur = ({ target: { value: nextValue } }) => {
      handleUserChange(nextValue)
      clickHandler()
    }

    const onAutocompleteChange = val => {
      const selection = val && val.fullSelection ? val.fullSelection.name : ''
      setValue(selection)
      if (val && val.fullSelection) {
        handleUserChange(val.fullSelection.id, val.fullSelection.name, inputId)
        clickHandler()
      }
    }

    return (
      <>
        {autocomplete ? (
          <Autocomplete
            id={INPUT_ID}
            dataTest={AUTOCOMPLETE}
            onChange={onAutocompleteChange}
            companyId={companyId}
            type={type}
            value={value}
          />
        ) : (
          <input
            id={INPUT_ID}
            onChange={inputChangeHandler}
            maxLength={maxLength}
            value={value}
            type={type}
            onBlur={onBlur}
          />
        )}
      </>
    )
  }
)

Editing.propTypes = {
  inputId: PropTypes.string,
  autocomplete: PropTypes.bool,
  companyId: PropTypes.number,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setValue: PropTypes.func.isRequired,
  handleUserChange: PropTypes.func,
  clickHandler: PropTypes.func.isRequired,
  maxLength: PropTypes.string,
}
Editing.defaultProps = {
  inputId: '',
  autocomplete: false,
  companyId: null,
  type: '',
  value: null,
  handleUserChange: () => {},
  maxLength: '',
}
